import React, { useState, useEffect } from 'react';
import { Drawer, Box, Typography, IconButton, Chip, Divider, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const sortOptions = [
    { value: 'default', label: 'Default' },
    { value: 'username_asc', label: 'Username (A-Z)' },
    { value: 'username_desc', label: 'Username (Z-A)' },
    { value: 'role', label: 'Role' },
];

const AdminUserSortDrawer = ({ open, onClose, selectedSort, onApplySort }) => {
    const [currentSort, setCurrentSort] = useState(selectedSort || 'default');

    useEffect(() => {
        if (open) setCurrentSort(selectedSort || 'default');
    }, [open, selectedSort]);

    const handleApply = () => {
        onApplySort(currentSort);
        onClose();
    };

    const handleClear = () => {
        setCurrentSort('default');
    };

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            keepMounted={false}
            disableRestoreFocus={true}
            PaperProps={{ sx: { width: { xs: '100%', sm: 340 }, display: 'flex', flexDirection: 'column' } }}
        >
            <Box sx={{ p: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ fontWeight: 'bold' }}>Sort</Typography>
                <IconButton onClick={onClose}><CloseIcon /></IconButton>
            </Box>
            <Divider />
            <Box sx={{ p: 3, flexGrow: 1, overflowY: 'auto' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>Sort by</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 3 }}>
                    {sortOptions.map(option => (
                        <Chip
                            key={option.value}
                            label={option.label}
                            onClick={() => setCurrentSort(option.value)}
                            sx={{
                                fontWeight: 500,
                                borderRadius: '16px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                                border: '1px solid transparent',
                                p: '12px 8px',
                                bgcolor: currentSort === option.value ? '#2563EB' : 'rgba(0, 0, 0, 0.05)',
                                color: currentSort === option.value ? 'white' : 'text.primary',
                                '&:hover': {
                                    bgcolor: currentSort === option.value ? '#1D4ED8' : 'rgba(0, 0, 0, 0.08)',
                                },
                            }}
                        />
                    ))}
                </Box>
            </Box>
            <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', bgcolor: 'background.paper', boxShadow: '0 -2px 10px rgba(0,0,0,0.05)' }}>
                <Button
                    fullWidth
                    variant="outlined"
                    onClick={handleClear}
                    size="large"
                    sx={{
                        mb: 2,
                        borderColor: 'text.secondary',
                        color: 'text.secondary',
                        '&:hover': {
                            borderColor: 'text.primary',
                            color: 'text.primary',
                        },
                        py: 1.5,
                        fontWeight: 'bold',
                        borderRadius: 3,
                        textTransform: 'none',
                        fontSize: '1rem'
                    }}
                >
                    Clear
                </Button>
                <Button
                    fullWidth
                    variant="contained"
                    onClick={handleApply}
                    size="large"
                    sx={{
                        bgcolor: '#2563EB',
                        '&:hover': { bgcolor: '#1D4ED8' },
                        py: 1.5,
                        fontWeight: 'bold',
                        borderRadius: 3,
                        textTransform: 'none',
                        fontSize: '1rem'
                    }}
                >
                    Apply sort
                </Button>
            </Box>
        </Drawer>
    );
};

export default AdminUserSortDrawer; 